import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';

// services
import { GlobleService } from 'src/app/core/services/globle.service';

// enums
import { Rent_Type } from 'src/app/core/enums/ads/rent-types';
import { Contract_Type } from 'src/app/core/enums/ads/contract-types';


@Injectable({
    providedIn: 'root'
})
export class IsAdsRentDailyGuard implements CanActivate {

    constructor(private G: GlobleService) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {

        // ES6 Destructuring & Nesting & rename
        const { 
            rentType,
            contractType,
        } = route?.data?.ads || {};  

        if (contractType == Contract_Type.RT && rentType == Rent_Type.DY) return true

        this.G.navigate(['/'])
        return false

    }

  
}
